import { render, staticRenderFns } from "./NavigationFavourite.vue?vue&type=template&id=7553f10b&"
import script from "./NavigationFavourite.vue?vue&type=script&lang=js&"
export * from "./NavigationFavourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports